module.exports = __webpack_public_path__ + "static/media/barclays-logo.c79b3439.png";